import React from "react";
import { motion, useReducedMotion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 34, className = "", once = true }) {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

// Word/line masked reveal for large headlines
export function MaskedLines({ lines, className = "", stagger = 0.12, delay = 0.1 }) {
  const reduce = useReducedMotion();
  if (reduce) {
    return (
      <div className={className}>
        {lines.map((l, i) => (
          <span key={i} className="block">{l}</span>
        ))}
      </div>
    );
  }
  return (
    <div className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask">
          <motion.span
            className="block"
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, delay: delay + i * stagger, ease: [0.16, 1, 0.3, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </div>
  );
}
